"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.McpServerTransport = void 0;
exports.McpServerTransport = {
    Sse: "SSE",
    StreamableHttp: "STREAMABLE_HTTP",
};
